<h2 mat-dialog-title class="participants-title">
  Teilnehmer – {{ data.event?.name || 'Event' }}
</h2>
<div class="participants-title-divider"></div>

<mat-dialog-content class="participants-content">
  <!-- Loading -->
  <div *ngIf="isLoading" class="participants-loading">
    <mat-icon class="participants-spinner">hourglass_empty</mat-icon>
    <span>Lade Teilnehmer...</span>
  </div>

  <!-- Empty state -->
  <p *ngIf="!isLoading && participants.length === 0" class="participants-empty">
    Keine Teilnehmer vorhanden.
  </p>

  <!-- Participant list -->
  <div class="participants-list" *ngIf="!isLoading && participants.length > 0">
    <mat-card
      class="participant-card"
      *ngFor="let participant of participants"
      [class.participant-not-attending]="!participant.attending">
      <div class="participant-info">
        <mat-icon class="participant-avatar">person</mat-icon>
        <div class="participant-details">
          <div class="participant-name">{{ getParticipantName(participant) }}</div>
          <div class="participant-status" [class.status-attending]="participant.attending" [class.status-not-attending]="!participant.attending">
            {{ participant.attending ? 'Angemeldet' : 'Abgemeldet' }}
          </div>
          <div class="participant-excuse" *ngIf="!participant.attending && participant.excuseText">
            Grund: {{ participant.excuseText }}
          </div>
        </div>
      </div>
      <div class="participant-actions">
        <div class="participant-actions-divider"></div>
        <mat-checkbox
          [checked]="participant.attending"
          [disabled]="isProcessing(participant)"
          (change)="onAttendingChange(participant)"
          color="primary"
          matTooltip="Teilnahme-Status">
        </mat-checkbox>
        <button
          mat-icon-button
          color="warn"
          [disabled]="isProcessing(participant)"
          (click)="onDeleteParticipant(participant)"
          aria-label="Teilnehmer entfernen"
          matTooltip="Entfernen">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </mat-card>
  </div>
</mat-dialog-content>

<div class="participants-bottom-divider"></div>

<mat-dialog-actions class="participants-actions">
  <button
    mat-raised-button
    color="primary"
    class="participants-btn add-btn"
    (click)="onAddParticipant()">
    <mat-icon>person_add</mat-icon>
    <span>Hinzufügen</span>
  </button>
  <button
    mat-stroked-button
    class="participants-btn close-btn"
    (click)="onClose()">
    <mat-icon>close</mat-icon>
    <span>Schließen</span>
  </button>
</mat-dialog-actions>
